<template>
  <div>
    <h1>
      {{ users.id != null ? $t("settings.users.userEdit") : $t("settings.users.userNew") }}
    </h1>

    <div class="mt-3 elevation-12 grey lighten-4">
      <v-tabs centered icons-and-text>
        <v-tab key="general">
          {{ $t("settings.users.personalData") }}
          <v-icon>account_box</v-icon>
        </v-tab>
        <v-tab key="permissions">
          {{ $t("settings.users.rolesAndPermissions") }}
          <v-icon>pan_tool</v-icon>
        </v-tab>
        <v-tab-item key="general">
          <v-card>
            <v-card-text>
              <v-form lazy-validation ref="form" v-model="formValid">
                <div
                  v-if="$store.getters['isWnbUser']"
                  style="text-align: center; display: block; background: white; z-index: 1; position: absolute; width: 300px; left: 50%; margin-top: 50px; margin-left: -150px; padding: 50px"
                  class="elevation-12"
                >
                  <img src="/img/wnb-logo-vertical.png" alt="Logo WNB" />
                  {{ $t("settings.users.settingsInWnb") }}
                  <v-btn block class="primary" @click="redirectToWnb">{{ $t("settings.users.goToWnbButton") }}</v-btn>
                </div>
                <v-radio-group :disabled="$store.getters['isWnbUser']" :mandatory="false" row v-model="users.sex">
                  <v-radio :label="$t('global.mr')" :value="1" />
                  <v-radio :label="$t('global.ms')" :value="2" />
                  <v-radio :label="$t('global.notSet')" :value="0" />
                </v-radio-group>
                <v-text-field
                  :disabled="$store.getters['isWnbUser']"
                  :label="$t('settings.users.fields.name.name') + '*'"
                  :rules="users.nameRules"
                  v-model="users.name"
                />
                <v-text-field
                  :disabled="$store.getters['isWnbUser']"
                  :label="$t('settings.users.fields.surname.name') + '*'"
                  :rules="users.surnameRules"
                  v-model="users.surname"
                />
                <v-text-field
                  :disabled="$store.getters['isWnbUser']"
                  :label="$t('settings.users.fields.login.name') + '*'"
                  :rules="users.loginRules"
                  v-model="users.login"
                />
                <v-text-field
                  :disabled="$store.getters['isWnbUser']"
                  :label="$t('settings.users.fields.email.name') + '*'"
                  :rules="users.emailRules"
                  v-model="users.email"
                />
                <v-checkbox :label="$t('settings.users.passwordByEmail')" v-model="passwordByMail"> </v-checkbox>
                <v-text-field
                  :label="$t('settings.users.fields.password.name') + '*'"
                  :placeholder="users.id != null ? $t('settings.users.fields.password.noChange') : ''"
                  :rules="users.passwordRules"
                  password
                  :disabled="users.password_by_mail"
                  type="password"
                  ref="passwordInput"
                  v-model="users.password"
                  v-if="!passwordByMail"
                />
                <v-text-field
                  :label="$t('settings.users.fields.repeatPassword.name') + '*'"
                  :placeholder="users.id != null ? $t('settings.users.fields.repeatPassword.noChange') : ''"
                  :rules="users.repeatPasswordRules"
                  :disabled="users.password_by_mail"
                  password
                  type="password"
                  ref="passwordInputRepeat"
                  v-model="users.repeatPassword"
                  v-if="!passwordByMail"
                />
                <v-text-field
                  :label="$t('settings.users.fields.integrationIdentifier.name')"
                  v-if="!$store.getters['isAdmin']"
                  v-model="users.integration_identifier"
                />
                <v-autocomplete
                  :items="availableSuperiors"
                  :label="$t('settings.users.fields.superiorUser.name')"
                  v-if="!$store.getters['isAdmin']"
                  v-model="users.superior_user_id"
                />
                <v-autocomplete
                  :items="availableOrganisationStructures"
                  :label="$t('settings.users.fields.organizationStructure.name')"
                  v-if="!$store.getters['isAdmin']"
                  v-model="users.organization_structure_id"
                />
                <v-autocomplete
                  :items="availablePrivateVehicles"
                  :label="$t('settings.users.fields.privateVehicle.name')"
                  v-if="!$store.getters['isAdmin']"
                  v-model="users.vehicle_private_id"
                />
                <v-autocomplete
                  :items="availableDefaultVehicles"
                  :label="$t('settings.users.fields.defaultVehicle.name')"
                  v-if="!$store.getters['isAdmin']"
                  v-model="users.vehicle_default_id"
                />
                <v-text-field :label="$t('settings.users.fields.bankName.name')" v-model="users.bank_name" v-if="!$store.getters['isAdmin']" />
                <v-text-field :label="$t('settings.users.fields.bankAccount.name')" v-if="!$store.getters['isAdmin']" v-model="users.bank_account_number" />
                <v-text-field :label="$t('settings.users.fields.costCentre.name')" v-if="!$store.getters['isAdmin']" v-model="users.cost_centre" />
                <location-ajax-select
                  :label="$t('global.homeLocation')"
                  v-if="!$store.getters['isAdmin']"
                  :placeholder="users.home_address_name"
                  :select-model.sync="users.home_address_id"
                />
                <location-ajax-select
                  :label="$t('global.workLocation')"
                  v-if="!$store.getters['isAdmin']"
                  :placeholder="users.work_address_name"
                  :select-model.sync="users.work_address_id"
                />
                <v-autocomplete
                  :clearable="true"
                  :items="availableDelegationGroups"
                  :label="$t('settings.users.fields.delegationRateGroup.name')"
                  v-if="!$store.getters['isAdmin']"
                  v-model="users.group_id"
                />
                <v-select
                  :items="languageChooser"
                  :label="$t('settings.users.fields.language.name')"
                  v-if="!$store.getters['isAdmin']"
                  v-model="users.language"
                >
                </v-select>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item key="permissions">
          <v-card>
            <v-card-text>
              <h2>{{ $t("settings.users.hasPermissions") }}</h2>

              <v-data-table
                :headers="headers"
                :items="hasAuthItems"
                hide-default-footer
                :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
              >
                <template #item="props">
                  <tr>
                    <td class="text-left">
                      {{ props.item.type == 2 ? $t("global.permission") : $t("global.role") }}
                    </td>
                    <td class="text-left">{{ props.item.translated_name }}</td>
                    <td class="text-left">{{ props.item.description }}</td>
                    <td class="text-left">
                      <v-btn @click.native="removeAuthItem(props.item.name)" icon>
                        <v-icon>clear</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  <v-alert color="error" icon="warning">
                    {{ $t("settings.users.noPermission") }}
                  </v-alert>
                </template>
              </v-data-table>

              <v-row class="mt-5 md-0" style="margin-bottom: 15px">
                <v-col
                  ><h3>{{ $t("settings.users.addPermissions") }}</h3></v-col
                >
                <v-spacer />
                <v-col cols="3">
                  <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
                </v-col>
              </v-row>

              <v-data-table :headers="headers" :items="availableAuthItems" :search="search">
                <template #item="props">
                  <tr>
                    <td class="text-left">
                      {{ props.item.type == 2 ? $t("global.permission") : $t("global.role") }}
                    </td>
                    <td class="text-left">{{ props.item.translated_name }}</td>
                    <td class="text-left">{{ props.item.description }}</td>
                    <td class="text-left">
                      <v-btn @click.native="addAuthItem(props.item.name)" icon>
                        <v-icon>add</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click.native="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import user from "../../../models/user";
import vehicleTypes from "../../../staticData/VehicleTypes";
import LocationAjaxSelect from "../../../components/CustomInputComponents/LocationAjaxSelect.vue";
import wnbAddresses from "../../../wnbAddresses";

export default {
  name: "AdminUsersNewView",
  components: { LocationAjaxSelect },
  data: () => ({
    users: new user(),
    allSuperiorUsers: [],
    allOrganisationStructures: [],
    allPrivateVehicles: [],
    formValid: true,
    allVehicles: [],
    allDelegationGroups: [],
    allAuthItems: [],
    search: null
  }),
  created() {
    if (typeof this.$route.params.id !== "undefined") {
      this.users.load(this.$route.params.id);
    }
    if (!this.$store.getters["isAdmin"]) {
      this.axios.get("settings/user/available-superior-users").then(resp => {
        this.allSuperiorUsers = resp.data;
      });
      this.axios.get("settings/user/available-organisation-structures").then(resp => {
        this.allOrganisationStructures = resp.data;
      });
      this.axios.get("settings/user/available-private-vehicles").then(resp => {
        this.allPrivateVehicles = resp.data;
      });
      this.axios.get("settings/user/available-default-vehicles").then(resp => {
        this.allVehicles = resp.data;
      });
      this.axios.get("settings/user/available-delegation-groups").then(resp => {
        this.allDelegationGroups = resp.data;
      });
    }
    this.axios.get("settings/user/available-auth-items").then(resp => {
      this.allAuthItems = resp.data;
    });
  },
  computed: {
    passwordByMail: {
      get() {
        return this.users.password_by_mail;
      },
      set(value) {
        this.users.password_by_mail = value;
        if (value === true) {
          this.users.password = "";
          this.users.repeatPassword = "";
        }
        this.$refs.passwordInput.validate();
        this.$refs.passwordInputRepeat.validate();
      }
    },
    languageChooser() {
      let result = [];
      result.push({
        text: this.$t("settings.users.fields.language.polish"),
        value: "pl-PL"
      });
      result.push({
        text: this.$t("settings.users.fields.language.english"),
        value: "en-US"
      });
      return result;
    },
    headers() {
      return [
        { text: this.$t("settings.users.type"), value: "type", width: "5%" },
        { text: this.$t("settings.users.name"), value: "name", width: "10%" },
        {
          text: this.$t("settings.users.description"),
          value: "description",
          width: "80%"
        },
        { text: this.$t("global.actions"), value: "actions", width: "5%" }
      ];
    },
    vehicleTypes: vehicleTypes,
    availableSuperiors() {
      const array = [];
      for (let superiorUser of this.allSuperiorUsers) {
        if (superiorUser.id !== this.users.id) {
          array.push({
            value: superiorUser.id,
            text: superiorUser.name + " " + superiorUser.surname + " (" + superiorUser.login + ")"
          });
        }
      }
      return array;
    },
    availableOrganisationStructures() {
      const array = [];
      for (let organisation of this.allOrganisationStructures) {
        array.push({
          value: organisation.id,
          text: organisation.name + " " + organisation.description
        });
      }
      return array;
    },
    availablePrivateVehicles() {
      const array = [];
      for (let vehicle of this.allPrivateVehicles) {
        array.push({
          value: vehicle.id,
          text:
            this.vehicleTypes.filter(vehicleType => vehicleType.id === vehicle.type).pop().name +
            " " +
            vehicle.model +
            " " +
            vehicle.engine_capacity +
            " cm3 (" +
            vehicle.plates +
            ")"
        });
      }
      return array;
    },
    availableDefaultVehicles() {
      const array = [];
      for (let vehicle of this.allVehicles) {
        array.push({
          value: vehicle.id,
          text:
            this.vehicleTypes.filter(vehicleType => vehicleType.id === vehicle.type).pop().name +
            " " +
            vehicle.model +
            " " +
            vehicle.engine_capacity +
            " cm3 (" +
            vehicle.plates +
            ")"
        });
      }
      return array;
    },
    availableDelegationGroups() {
      const array = [];
      for (let delegationGroup of this.allDelegationGroups) {
        array.push({
          value: delegationGroup.id,
          text: delegationGroup.name + " " + delegationGroup.description
        });
      }
      return array;
    },
    availableAuthItems() {
      const array = [];
      for (let authItem of this.allAuthItems.filter(this.filterAlreadyHaveItems)) {
        array.push(authItem);
      }
      return array;
    },

    hasAuthItems() {
      const array = [];
      for (let authItem of this.allAuthItems) {
        for (let userAuthItem of this.users.auth_items) {
          if (userAuthItem === authItem.name) {
            array.push(authItem);
          }
        }
      }
      return array;
    }
  },
  methods: {
    wnbAddresses: wnbAddresses,
    save() {
      if (this.$refs.form.validate()) {
        this.users
          .save()
          .then(() => {
            this.$router.push({ path: "/admin/users" });
          })
          .catch(response => {
            this.$store.dispatch("alertDialog", {
              content: this.$t("global.error.generalError.content") + response,
              title: this.$t("global.error.generalError.title")
            });
          });
      }
    },
    addAuthItem(authItemName) {
      this.users.auth_items.push(authItemName);
    },
    removeAuthItem(authItemName) {
      this.users.auth_items.splice(this.users.auth_items.indexOf(authItemName), 1);
    },
    filterAlreadyHaveItems(item) {
      for (let userAuthItem of this.users.auth_items) {
        if (userAuthItem === item.name) {
          return false;
        }
      }
      return true;
    },
    cancel() {
      this.$router.push({ path: "/settings/users" });
    },
    redirectToWnb() {
      window.location.href = this.wnbAddresses("USER") + "/" + this.users.email;
    }
  }
};
</script>

<style scoped></style>
